import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  label: {
    fontSize: '0.75rem',
  },
}));

// Important to not pass on the omitted values.
const File = ({ field, form, ...props }: any) => {
  const classes = useStyles();
  return (
    <div>
      <p className={classes.label}>{props.label}</p>
      <input
        {...props.field}
        {...props}
        type="file"
        onChange={(event) => {
          if (
            event.currentTarget !== null &&
            event.currentTarget.files?.length
          ) {
            form.setFieldValue(field.name, event.currentTarget.files[0]);
          }
        }}
      />
    </div>
  );
};

export default File;
